"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _ChevronDown = _interopRequireDefault(require("../../icons-react/rebrand/ChevronDown"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FacilitiesTitle = function FacilitiesTitle(_ref) {
  var count = _ref.count,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    onToggle = _ref.onToggle,
    isOpened = _ref.isOpened,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, onToggle ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    functional: true,
    onClick: onToggle
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, children), /*#__PURE__*/_react["default"].createElement(StyledCounter, null, count), /*#__PURE__*/_react["default"].createElement(StyledChevronDownIcon, {
    $inverted: !!isOpened
  })) : /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, children)));
};
var StyledTitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesTitle__StyledTitleContainer",
  componentId: "sc-17yi8dw-0"
})(["margin-bottom:9px;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesTitle__StyledTitle",
  componentId: "sc-17yi8dw-1"
})(["font-style:normal;font-weight:500;", ""], function (props) {
  return props.isMobile ? (0, _styledComponents.css)(["font-size:18px;line-height:22px;padding-left:10px;"]) : (0, _styledComponents.css)(["font-size:22px;line-height:26px;"]);
});
var StyledCounter = _styledComponents["default"].span.withConfig({
  displayName: "FacilitiesTitle__StyledCounter",
  componentId: "sc-17yi8dw-2"
})(["font-size:15px;margin:2px 5px 0 10px;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "FacilitiesTitle__StyledButton",
  componentId: "sc-17yi8dw-3"
})(["display:flex;align-items:center;"]);
var StyledChevronDownIcon = (0, _styledComponents["default"])(_ChevronDown["default"]).withConfig({
  displayName: "FacilitiesTitle__StyledChevronDownIcon",
  componentId: "sc-17yi8dw-4"
})(["display:inline-flex;align-items:center;margin:auto 0;height:12px;", ""], function (_ref2) {
  var $inverted = _ref2.$inverted;
  return $inverted && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});
var _default = exports["default"] = FacilitiesTitle;